
export function getLatestReview(reviews) {
    if (!Array.isArray(reviews) || reviews.length === 0) return null;

    return reviews.reduce((latest, current) => {
        if (!latest) return current;
        return new Date(current.decision_timestamp) > new Date(latest.decision_timestamp)
            ? current
            : latest;
    }, null);
}
